import { axiosFactory, errorHandler } from '@/configs/axios'

const plansSolutionsList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams()

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== '') {
          queryParams.append(key, value)
        }
      }
    }

    // Preserve current page from URL (?p=)
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const page = urlParams.get('p')
      if (page) {
        queryParams.append('p', page)
      }
    } catch (e) {
      // window might not be available in some contexts; safely ignore
    }

    const queryString = queryParams.toString()
    const url = `plans/solutions/${queryString ? `?${queryString}` : ''}`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const exportPlan = {
  api: (fromDate, toDate) => {
    return axiosFactory({ type: 'blob' })
      .auth.get(`exports/plans/?route__solution__date__gte=${fromDate}&route__solution__date__lte=${toDate}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export { plansSolutionsList, exportPlan }
